export interface Category {
  name: string;
  url: string;
  seq: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    seq: "cat-shoes-01",
  },
  {
    name: "Hoodies & Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    seq: "cat-hoodies-02",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    seq: "cat-tshirts-03",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    seq: "cat-jackets-04",
  },
  {
    name: "Pants & Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    seq: "cat-pants-05",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    seq: "cat-headwear-06",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    seq: "cat-sets-07",
  },
  {
    name: "Underwear & Underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    seq: "cat-underwear-08",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    seq: "cat-jersey-09",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    seq: "cat-accessories-10",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    seq: "cat-bags-11",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    seq: "cat-belts-12",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    seq: "cat-perfumes-13",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    seq: "cat-other-14",
  },
];